import { UniversitySearchPayload } from '../models/university-search.models';

const currentYear = new Date().getFullYear();

export const HEADER_DATA = {
	title: 'Search UK universities',
	description:
		'Find the right place for you and browse universities from across the country. From lively universities in the heart of northern cities to coastal campuses in the south, discover all UK universities.',
};

export const HEADER_CLEARING_DATA = {
	...HEADER_DATA,
	title: `Clearing Universities ${currentYear}`,
};

export const METADATA = {
	title: 'Search & Find A University',
	description:
		'Find a university at Uni Compare with our free online university finder. With over 400 institutes to search from, you can find the perfect university to study at today!',
};

export const DEFAULT_UNIVERSITY_SEARCH_PAYLOAD: UniversitySearchPayload = {
	product: 'UNDERGRADUATE',
	name: '',
	locationIds: null,
	page: 1,
	limit: 20,
	offset: null,
	fromStart: true,
	merge: false,
};
